import { resolveName } from 'components/form/core/hooks/useField'
import { MetaPath } from 'util/metaPath'

export const resolveLabelKey = <TFieldModel>(fieldName: MetaPath<TFieldModel>) =>
  resolveName(fieldName).replaceAll('.', '.fields.')
